export default "__VITE_ASSET__eG06vwiy__"